import { useContext, useState } from "react";
import cn from "classnames";
import { IconName, Button } from "capitalrx-components-2.0/lib/general";
import RequestModal from "@/components/GetCardModals/RequestModal";
import { RequestTypes } from "@/api/interfaces/AdvantageCardRequest";

import styles from "./ButtonComponent.module.scss";
import { ThemeSelectorContext } from "@/context/index";

interface Props {
  buttonText: string;
  requestType?: RequestTypes;
  iconName: string;
  className?: string;
  testId?: string;
}

const ButtonComponent: React.FC<Props> = (props: Props) => {
  const { buttonText, requestType, iconName, testId, className } = props;
  const [showModalState, setShowModalState] = useState(false);
  const [modalType, setModalType] = useState<RequestTypes>(RequestTypes.null);
  const { client } = useContext(ThemeSelectorContext);

  const buttonClass = cn(styles.CardButton, { [styles.WhitelabelButton]: !!client }, className);

  const showModal = (type: RequestTypes): void => {
    setModalType(type);
    setShowModalState(true);
  };

  const closeModal = (): void => {
    setShowModalState(false);
  };

  const buttonComponent = (
    <Button
      testId={testId}
      className={buttonClass}
      onClick={() => showModal(requestType)}
      appearance={"primary"}
      iconPosition="left"
      icon={iconName as IconName}
    >
      {buttonText}
    </Button>
  );

  return (
    <>
      <div className={styles.ButtonAlignment}>{buttonComponent}</div>
      <RequestModal type={modalType} visible={showModalState} onClose={closeModal} />
    </>
  );
};

export default ButtonComponent;
